export default __webpack_public_path__ + "static/media/harmay-background.138c5bfb.png";